// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IDriverAlertValuesRequest {
	triggerId: string | undefined;

	minValue: number | undefined;

	additionalValue: number | undefined;

	maxValue: number | undefined;

	$type?: string | undefined;
}
export class DriverAlertValuesRequest {
	constructor(data?: IDriverAlertValuesRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	triggerId: string | undefined;

	minValue: number | undefined;

	additionalValue: number | undefined;

	maxValue: number | undefined;

	static $type: string = "CoreApi.Models.DriverAlertValuesRequest, ";
	$type?: string | undefined = DriverAlertValuesRequest.$type;
}

